module.exports = __webpack_public_path__ + "static/media/ContactPge.fdeca1f7.png";